"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeUtil = void 0;
const bytes = require("bytes");
class SizeUtil {
    constructor() { }
    static toBytes(size) {
        return bytes(size);
    }
    /**
     * @returns length of string or stringified object
     */
    static byteCount(value) {
        if (!value)
            return 0;
        if (typeof value === 'string')
            return value.length;
        const stringified = JSON.stringify(value);
        // console.log(stringified)
        return stringified.length;
    }
}
exports.SizeUtil = SizeUtil;
